import { combineReducers } from 'redux'
import bundleInfo from './bundle/reducer'
import corporateData from './corporate/reducer'
import CustomerInfoData from './customerInfo/reducer'
import PaltelcustomerInfoData from './fixedLineCustomerInfo/reducer'
import Language from './language/reducer'
import LoginData from './login/reducer'
import Mode from './modeTheme/reducer'
import offersData from './offers/reducer'
import paymentData from './payment/reducer'
import sharedFlags from './sharedFlags/reducer'
import quotaData from './quota/reducer'
import fixedLineHotOffers from './fixedLineHotOffers/reducer'
import paltelCorporateData from './paltelCorporate/reducer'
import traceReducer from './trace/reducer'
import fixedLineSOHOCustomerInfoData from './fixedLineSOHOCustomerInfo/reducer'
export const allReducers = combineReducers({
  LoginData,
  Language,
  offersData,
  fixedLineHotOffers,
  bundleInfo,
  CustomerInfoData,
  PaltelcustomerInfoData,
  paymentData,
  quotaData,
  Mode,
  corporateData,
  sharedFlags,
  paltelCorporateData,
  traceReducer,
  fixedLineSOHOCustomerInfoData
})

export const rootReducer = (state, action) => {
  if (action.type === 'RESET_APP') {
    state = undefined
  }
  return allReducers(state, action)
}
